import { useTranslation } from 'react-i18next';

import passwordIcon from 'assets/img/icons/passwordIcon.svg';

export const getFields = () => {
  const { t } = useTranslation();

  return [
    {
      name: 'oldPassword',
      label: t('change.password.currentPassword'),
      type: 'password',
      icon: passwordIcon,
      dataLocator: 'CurrentPasswordInput',
    },
    {
      name: 'newPassword',
      label: t('change.password.newPassword'),
      type: 'password',
      icon: passwordIcon,
      dataLocator: 'newPasswordInput',
    },
    {
      name: 'confirmNewPassword',
      label: t('change.password.confirmPassword'),
      type: 'password',
      icon: passwordIcon,
      dataLocator: 'newPasswordConfirmationInput',
    },
  ] as const;
};
